export default __webpack_public_path__ + "static/Flexibility-cd476e82d14d7db7706591bb86bdc00e.png";